// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__1cVGv","loader":"loading_loader__2Wmei","load8":"loading_load8__3IMF3"};